import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Title } from '../layout';

export class ProgramsComponent extends Component {

  render() {

    return (
      <div>
        <Title title="Program Access"/>
        <h1>
          Program Access
        </h1>
      </div>
    );
  }
}

ProgramsComponent.propTypes = {
};

const mapStateToProps = () => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgramsComponent);
